module.exports = require('./cjs/nivo-pie')



//////////////////
// WEBPACK FOOTER
// ./~/@nivo/pie/index.js
// module id = 1194
// module chunks = 0